orders-planner-line-ui
  .back-col
    orders-planner-line-back(tag-scope="orders_planner_line_back" data-line-id="{this.opts.id}")
  .dates-col
    orders-planner-line-ui-cells(tag-scope="{this.tagScope}")
    orders-planner-line-ui-schedules(tag-scope="{this.tagScope}")
  .forward-col
    orders-planner-line-forward(tag-scope="orders_planner_line_forward" data-line-id="{this.opts.id}")
  script(type="typescript").
    this.mixin('orders.planner.line');
